import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { LmBasicRouteProps } from 'src/utils/routerSupportTypes';

import { IMessage, showMessage } from '../actions/message';
import MessageDialog from '../components/MessageDialog';
import Progress from '../components/Progress';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import * as Scenario from '../scenario/loginSso';

// import backgroundImage from '../images/login_bg.jpg';
import logoImage from '../images/logo.png';

const styles = (theme: Theme) =>
	createStyles({
		appHeader: {
			[theme.breakpoints.up('md')]: {
				padding: theme.spacing(1),
				width: '100%',
			},
		},
		appMain: {
			paddingLeft: theme.spacing(4),
			paddingRight: theme.spacing(4),
			[theme.breakpoints.up('md')]: {
				alignItems: 'center',
				display: 'flex',
				flexDirection: 'column',
				paddingTop: theme.spacing(20),
			},
		},
		bootstrapInput: {
			'&:focus': {
				borderColor: '#80bdff',
				boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
			},
			backgroundColor: theme.palette.common.white,
			border: '1px solid #ced4da',
			borderRadius: 4,
			fontSize: 16,
			padding: '10px 12px',
			transition: theme.transitions.create([
				'border-color',
				'box-shadow',
			]),
			width: 'calc(100% - 24px)',
		},
		bootstrapRoot: {
			'label + &': {
				marginTop: theme.spacing(3),
			},
			padding: 0,
		},
		container: {
			[theme.breakpoints.up('md')]: {
				display: 'flex',
				flexDirection: 'row-reverse',
				flexWrap: 'wrap',
				width: '960px',
			},
		},
		form: {
			maxWidth: '100%', // for I.E.
		},
		formControl: {
			backgroundColor: 'white',
			marginBottom: theme.spacing(1),
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
		},
		loginForm: {
			paddingBottom: theme.spacing(1),
			[theme.breakpoints.up('md')]: {
				padding: theme.spacing(1),
				width: '300px',
			},
		},
		loginNotice: {
			[theme.breakpoints.up('md')]: {
				flex: 1,
				padding: theme.spacing(1),
				width: '660px',
			},
		},
		logoBox: {
			[theme.breakpoints.up('md')]: {
				// margin: 0,
				// maxWidth: '1020px',
			},
		},
		paper: {
			alignItems: 'center',
			backgroundColor: 'rgba(192,255,255,0.2)',
			color: 'white',
			display: 'flex',
			flexDirection: 'column',
			padding: `${theme.spacing(2)}px ${theme.spacing(
				3
			)}px ${theme.spacing(3)}px`,
		},
		root: {
			backgroundColor: '#257ec0',
			// backgroundImage: `url(${backgroundImage})`,
			backgroundSize: 'cover',
			minHeight: '100vh',
			minWidth: '100vw',
		},
		submit: {
			marginTop: theme.spacing(3),
		},
	});

interface IState {
	userName: string;
	password: string;
}

/**
 * ログイン画面用コンポーネント
 */
class LoginSso extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			password: '',
			userName: '',
		};
		this.props.loginSso();
	}

	/**
	 * 画面描画時処理
	 * 管理者からのお知らせを取得し、画面表示する
	 */
	public componentDidMount() {
		if (this.props.fetchedMessagesAt) {
			return;
		}
		this.props.fetchMessages(this.props.match.params.company_code);
	}

	/**
	 * 画面描画処理
	 */
	public render() {
		const { classes, isShowProgress } = this.props;

		return (
			<div className={classes.root}>
				<Progress open={isShowProgress} />

				<MessageDialog
					open={this.props.message.open}
					contents={this.props.message.messages}
					title={this.props.message.title}
					showCancelButton={false}
					onClickOk={this.handleDialogClose}
					onClose={this.handleDialogClose}
					messageNs="loginmessage"
				/>
			</div>
		);
	}

	protected LoginForm: React.FC<{}> = props => {
		const { classes } = this.props;

		return (
			<div className={classes.loginForm}>
				<Paper className={classes.paper}>
					<form
						noValidate={true}
						autoComplete="off"
						className={classes.form}
					>
						<FormControl
							margin="normal"
							required={true}
							fullWidth={true}
						>
							<Input
								id="userName"
								name="userName"
								value={this.state.userName}
								placeholder={i18n.t('LoginSso_0001')}
								onChange={this.handleChange('userName')}
								onKeyPress={this.handleKeyPress}
								autoFocus={true}
								disableUnderline={true}
								classes={{
									input: classes.bootstrapInput,
									root: classes.bootstrapRoot,
								}}
							/>
						</FormControl>
						<FormControl
							margin="normal"
							required={true}
							fullWidth={true}
						>
							<Input
								id="password"
								name="password"
								type="password"
								value={this.state.password}
								placeholder={i18n.t('LoginSso_0002')}
								onChange={this.handleChange('password')}
								onKeyPress={this.handleKeyPress}
								disableUnderline={true}
								classes={{
									input: classes.bootstrapInput,
									root: classes.bootstrapRoot,
								}}
							/>
						</FormControl>
						<Button
							variant="contained"
							color="primary"
							fullWidth={true}
							onClick={this.handleLogin}
							className={classes.submit}
						>
							{i18n.t('LoginSso_0003')}
						</Button>
					</form>
				</Paper>
			</div>
		);
	};

	/**
	 * 入力項目変更処理
	 */
	protected handleChange = (name: string) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		this.setState({
			...this.state,
			[name]: target.value,
		});
	};

	/**
	 * キー入力処理
	 * Enterキーが押された際、ログインする
	 */
	protected handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === 'Enter') {
			this.handleLogin();
		}
	};

	/**
	 * ログイン処理
	 */
	protected handleLogin = () => {
		this.props.loginSso();
	};

	/**
	 * ダイアログ非表示処理
	 */
	protected handleDialogClose = () => {
		this.props.showMessage([], '');
		location.href = this.props.accessURL;
	};

	/**
	 * ヘッダ部コンポーネント
	 */
	protected Header: React.FC<Pick<IProps, 'classes'>> = ({ classes }) => (
		<header className={classes.appHeader}>
			<div className={classes.logoBox}>
				<img src={logoImage} />
			</div>
		</header>
	);
}

const mapStateToProps = (state: IRootState) => ({
	accessURL: state.loginSso.accessURL,
	carouselChangeInterval: state.login.carouselChangeInterval,
	fetchedMessagesAt: state.login.fetchedMessagesAt,
	isShowProgress: state.login.isShowProgress,
	message: state.message,
	messages: state.login.messages,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchMessages: (companyCode: string | undefined) =>
		Scenario.fetchMessages(dispatch, companyCode),
	loginSso: () => Scenario.loginSso(dispatch, 1),
	showMessage: (messages: IMessage[], title: string) =>
		dispatch(showMessage({ messages, title })),
});

// tslint:disable-next-line: no-empty-interface
export interface ILoginSsoProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ILoginSsoProps & LmBasicRouteProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(LoginSso);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ILoginSsoProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/LoginSso.tsx